import React, { useState } from 'react';
import { Routes, Route } from 'react-router-dom';
import { Box } from '@mui/material';
import AppHeader from './components/AppHeader';
import Sidebar from './components/Sidebar';
import Dashboard from './components/Dashboard';
import SensorDetailView from './components/SensorDetailView';
import ComparisonView from './components/ComparisonView';
import PredictionView from './components/PredictionView';
import SettingsView from './components/SettingsView';
import SensorList from './components/SensorList';
import WashesView from './components/WashesView';

function App() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  
  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
      <AppHeader toggleSidebar={toggleSidebar} />
      <Box sx={{ display: 'flex', flex: 1, overflow: 'hidden' }}>
        <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />
        <Box component="main" sx={{ flexGrow: 1, p: 3, overflow: 'auto' }}>
          <Routes>
            <Route path="/" element={<Dashboard />} />
            {/* Tunnel hierarchy routes */}
            <Route path="/tunnels" element={<SensorList />} />
            <Route path="/tunnels/:tunnelId" element={<SensorDetailView />} />
            {/* Backward compatibility */}
            <Route path="/sensors" element={<SensorList />} />
            <Route path="/sensor/:sensorId" element={<SensorDetailView />} />
            <Route path="/readings/:readingType" element={<SensorDetailView />} />
            {/* Other app routes */}
            <Route path="/comparison" element={<ComparisonView />} />
            <Route path="/comparison/:tunnelId" element={<ComparisonView />} />
            <Route path="/predictions" element={<PredictionView />} />
            <Route path="/washes" element={<WashesView />} />
            <Route path="/settings" element={<SettingsView />} />
          </Routes>
        </Box>
      </Box>
    </Box>
  );
}

export default App;